import 'whatwg-fetch';
import { checkStatus, authorization } from 'actions/utils/fetch_utils';
import { apiBasename } from 'actions/config/api';

export const fetchInvoiceModificationCategories = () => {
	return fetch(apiBasename + '/invoiceModificationCategory', authorization())
	.then(checkStatus)
	.then((res) => res.json());
}
